<template>
    <v-layout row wrap justify-center>
        <v-flex xs12>
            <div class="text-xs-left">
                <v-btn
                        flat
                        @click="goBack(item.group_id)"
                >
                    <v-icon left small>fal fa-chevron-left</v-icon>
                    {{ item.group_description }}
                </v-btn>
            </div>
        </v-flex>
        <v-flex xs12 sm8 md6>
            <!-- Displaying the various images of the Item -->
            <div v-if="baseUrl && item.images && item.images.length > 1" style="position: relative">
                <v-carousel hide-controls height="auto">
                    <v-carousel-item v-for="itemImage in item.images" :key="itemImage.image">
                        <v-card>
                            <v-img :src="baseUrl + itemImage" aspect-ratio="1.48"></v-img>
                        </v-card>
                    </v-carousel-item>
                </v-carousel>

                <div v-if="item.price_percent_discount > 0"
                     class="title catalog-item-image-promo primary white--text">
                    -{{ item.price_percent_discount }}%
                </div>
            </div>
            <div v-if="baseUrl && item.images && item.images.length === 1">
                <v-img v-bind:src="baseUrl + item.images[0]"
                       aspect-ratio="1.48">
                </v-img>
            </div>
        </v-flex>

        <v-flex xs12 md6 class="pl-4 pt-4">
            <!--            <v-card>-->
            <!--                <v-card-title primary-title>-->
            <div>
                <h1 class="display-1 catalog-item-title">{{ item.name }}</h1>

                <br/>
                <span v-if="item.description" v-html="item.description"></span>

                <br v-if="item.description"><br>

                <h2 v-if="item.stock > 0"
                    class="green--text">{{ $vuetify.t('$vuetify.shop.shop_item_stock') }}</h2>
                <h2 v-if="item.stock <= 0" class="error--text">{{ $vuetify.t('$vuetify.shop.shop_item_nostock') }}</h2>

                <br>
                <h1>
                    <span v-if="item.price" class="primary--text">{{ item.price }}&nbsp;{{ currencySymbol }}</span>
                    <span v-if="item.old_price" class="red--text title pl-3"
                          style="text-decoration: line-through">{{ item.old_price }}&nbsp;{{ currencySymbol }}</span>
                    <span v-if="item.old_price && item.price_percent_discount>0"
                          class="red--text title pl-2">(-{{ item.price_percent_discount }}%)</span>
                </h1>

                <span v-if="item.price_per_unit" class="grey--text subheading">
                    {{ item.price_per_unit }}&nbsp;{{ currencySymbol }}{{ item.price_per_unit_type }}
                </span>
                <span v-if="item.old_price_per_unit" class="grey--text pl-2"
                      style="text-decoration: line-through">
                    {{ item.old_price_per_unit }}&nbsp;{{ currencySymbol }}{{ item.old_price_per_unit_type }}
                </span>
                <br>
                <span v-if="item.price_end_date" class="grey--text">
                    {{ $vuetify.t('$vuetify.shop.promo_valid_until') }}&nbsp;{{ item.price_end_date }}
                </span>


            </div>
            <div v-if="item.menu" class="text-xs-center pt-5">
                <v-btn
                        @click="goToChooseMenuOptions(item.menu)"
                        class="primary"
                        large>
                    <v-icon left small>far fa-tasks</v-icon>
                    {{ $vuetify.t('$vuetify.shop.item_define_menu') }}
                </v-btn>
            </div>

            <!--                </v-card-title>-->
            <!--                <v-card-actions style="align-content: center">-->
            <!--                    <v-select v-if="item.variants && item.variants.length > 0"-->
            <!--                              :items="item.variants"-->
            <!--                              item-value="value"-->
            <!--                              item-text="text"-->
            <!--                    ></v-select>-->
            <div v-if="item.price && item.stock > 0 && !item.menu" class="text-xs-center pt-5">
                <v-btn large color="primary" @click="addToCart(item.id)"
                       class="mr-0">
                    <v-icon left small>fal fa-shopping-cart</v-icon>
                    {{ $vuetify.t('$vuetify.add') }}
                </v-btn>
            </div>
        </v-flex>
        <!--                </v-card-actions>-->
        <!--            </v-card>-->

        <v-flex xs12 class="pl-4 pr-4">
            <v-expansion-panel v-if="item.ingredients"
                               expand
                               style="background:transparent"
            >
                <v-expansion-panel-content :readonly="false" :hide-actions="false"
                                           style="background:transparent">
                    <template v-slot:header>
                        <h3 class="primary--text">{{ $vuetify.t('$vuetify.ingredients') }}</h3>
                    </template>
                    <v-card>
                        <v-card-text v-html="item.ingredients"></v-card-text>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="item.nutrition" expand>
                <v-expansion-panel-content :readonly="false" :hide-actions="false"
                                           style="background:transparent">
                    <template v-slot:header>
                        <h3 class="primary--text">{{ $vuetify.t('$vuetify.info_nutritional') }}</h3>
                    </template>
                    <v-card>
                        <v-card-text v-html="item.nutrition"></v-card-text>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-flex>

    </v-layout>
</template>
<script>
import {itemsService} from '@/_services/shop/items.service';
import { getErrorMessage} from '@/_helpers';
import {mapGetters} from "vuex";

export default {
    name: "CatalogItemDetail",
    data() {
        return {
            item: {},
        }
    },
    computed: {
        ...mapGetters({
            currencySymbol: 'configs/currencySymbol',
            baseUrl: 'configs/apiImgBaseUrl',
        }),
    },
    methods: {
        /**
         * Adding a new Item to the Shopping Cart, which is stored on the local storage
         * @param pk
         */
        addToCart: function (pk) {
            this.$store.dispatch("shop/addToCart", pk);
        },
        /**
         * The method assigned to the button which allows the user to return to the Group to which the Item belongs to.
         **/
        goBack(group) {
            this.$router.push({name: "shop-group-detail-items", params: {group: group}});
        },
        /**
         *
         **/
        goToChooseMenuOptions(menu) {
            this.$router.push({name: "shop-item-detail-menu", params: {id: menu}});
        },
    },
    mounted() {
        this.item_identifier = parseInt(this.$route.params.id);

        this.$store.dispatch("loader/setLoading", true);

        itemsService.get(this.item_identifier).then(result => {
                this.item = result;
                this.$store.dispatch("loader/setLoading", false);

                //The change of the toolbar title has to be managed inside the promise where the item is obtained
                // After setting the meta, it is necessary to force the router to reload.
                // Which is achieved by changing the query parameter
                this.$route.meta.toolbarTitle = this.item.name;
                // Add a temporary query parameter.
                this.$router.replace({query: {temp: Date.now()}});
                // Remove the temporary query parameter.
                this.$router.replace({query: {temp: undefined}});
            },
            error => {
                getErrorMessage(error, 'Getting the Item Detail', this);
            }
        );
    }
}
</script>

<style scoped>

</style>